<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="infoDiv">
          <el-row :gutter="20">
            <el-col :span="16">
              <!--              <h3>联系我们</h3>-->
              <h3>Contact Us</h3>
            </el-col>
            <el-col :span="8"></el-col>
          </el-row>
          <el-row :gutter="20" class="contact-row">
            <el-col :span="5">
              <!-- <i class="el-icon-phone"></i> 0871-66662888 -->
              <i class="el-icon-message"></i> Info@cirgou.com
            </el-col>
            <el-col :span="6">

            </el-col>
            <el-col :span="13">
              <!--              <i class="el-icon-location"></i> 福建省福州市科普路505号五华科创大厦-->
              <!-- <i class="el-icon-location"></i> High praise for Wuhua Science and Technology Innovation Building -->
            </el-col>
          </el-row>
          <el-row :gutter="20" class="contact-row">
            <el-col :span="16">
              <!--              Copyright ©2025 cirgou 版权所有 闽ICP备11066888-9号-->
              Copyright @2025 Cirgou
            </el-col>
          </el-row>
        </div>
        <div class="downloadDiv" @click="downloadAppFun()">
          <div>
            <img src="@/assets/download-logo.png">
          </div>
          <div style="padding-left: 34px;">
            <span class="downloadSpan">Download App</span>
          </div>
        </div>
        <div class="ewmDiv">
          <div class="qiyeTextDiv">
            <!--            <span>企业公众号</span>-->
            <span>Official Account</span>
          </div>
          <div>
            <img src="@/assets/erweim.png">
          </div>
        </div>

      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    downloadAppFun() {
      this.$router.replace({ path: '/Download' })
    }
  }
}

</script>

<style scoped>
.footer {
  background: #333;
  color: #fff;
  padding: 50px 0 20px;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
}
.down-join-ewm {
  display: flex;
  justify-content: space-between;
}

.footer-section {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
}

.footer-section h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-section p {
  margin-bottom: 10px;
  color: #bbb;
  cursor: pointer; /* 鼠标悬停时显示手型指针 */
}

.footer-section p:hover {
  color: #fff;
}

.copyright {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #444;
  color: #bbb;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
}

.infoDiv {
  width: 1000px;
}

.downloadDiv {
  flex-direction: column;
  width: 230px;
  cursor: pointer; /*鼠标手效果*/
  padding-top: 41px;
}

.ewmDiv {
  flex-direction: column;
  width: 130px;
}
.downloadSpan {
  height: 19px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #C3C5C8;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

h3 {
  font-size: 18px;
}

.ewmDiv img {
  height: 100px;
  width: 100px;
}

.qiyeTextDiv {
  margin-bottom: 20px;
}

.contact-row {
  color: #C3C5C8;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue